import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/jackpot.css";
import App from "@/App";
import { registerSW } from "@/lib/push";
import { startAutoUpdate } from "@/lib/autoUpdate";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { API } from "@/lib/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

registerSW();
startAutoUpdate();

// Keep the app on the canonical domain only (e.g. redirect www / platform hosts).
if (!["localhost", "127.0.0.1"].includes(window.location.hostname)) {
  fetch(`${API}/public/config`).then((r) => r.json()).then(({ canonical_url }) => {
    const target = new URL(canonical_url);
    if (target.host && target.host !== window.location.host) {
      window.location.replace(`${target.origin}${window.location.pathname}${window.location.search}${window.location.hash}`);
    }
  }).catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

const splash = document.getElementById("app-splash");
if (splash) setTimeout(() => { splash.style.opacity = "0"; splash.style.transform = "scale(1.08)"; setTimeout(() => splash.remove(), 550); }, 3000);
